<template>
    <div>
        <v-content>
            <v-row>
                <v-col cols="8" lg="8" xl="8">
                    <v-card class="section-card pa-5" outlined>
                        <NewsStories :top-news="news" :sentiment-analysis="sentiments"/>
                    </v-card>
                </v-col>
                <v-col cols="4" lg="4" xl="4">
                    <v-card class="section-card pa-5" outlined>
                        <SocialFeed :tweets="tweets"/>
                    </v-card>
                </v-col>
            </v-row>
        </v-content>
    </div>
</template>

<script>
    import NewsStories from "./NewsStories";
    import SocialFeed from "./SocialFeed";

    export default {
        name: "FundamentalOverview",
        components: {
            SocialFeed,
            NewsStories
        },
        beforeMount(){
          this.getTweets();
          this.getNews();
        },
        data() {
            return {
                tweets: [],
                news: [],
                sentiments: [],
            }
        },
        methods: {
            getTweets() {
                this.tweets = [
                    {
                        tweet: 'We have become a far greater Economic Power than ever before, and we are using that power for WORLD PEACE!',
                        user: 'realDonaldTrump',
                        userImage: 'https://pbs.twimg.com/profile_images/874276197357596672/kUuht00m_400x400.jpg',
                        link: 'https://twitter.com/realDonaldTrump/status/1183390085993119749',
                        date: '13-10-19',
                        likes: 18641,
                        retweets: 5000
                    },
                    {
                        tweet: 'The Endless Wars Must End!',
                        user: 'realDonaldTrump',
                        userImage: 'https://pbs.twimg.com/profile_images/874276197357596672/kUuht00m_400x400.jpg',
                        link: 'https://twitter.com/realDonaldTrump/status/1183130243885875200',
                        date: '13-10-19',
                        likes: 121053,
                        retweets: 26251
                    },
                    {
                        tweet: 'So I take to the $DXY dollar index chart to look for clues where $gold is headed though $EURUSD is a more direct trading vehicle. It looks like we had a bunch of RSI divergent highs on the weekly and daily. RSI breakdown on the daily already, breakdown on weekly looks imminent.\n',
                        user: 'arfwid',
                        userImage: 'https://pbs.twimg.com/profile_images/874276197357596672/kUuht00m_400x400.jpg',
                        link: 'https://twitter.com/arfwid/status/1183102429962887168',
                        date: '12-10-19',
                        likes: 0,
                        retweets: 0
                    },
                    {
                        tweet: 'Germany 2 Year $Bond Yield 📈 US 2 Year $Bond Yield 📉\n\nEqual to short term rebound continuation? 📈 $EURUSD\n',
                        user: 'MMelchiorsen',
                        userImage: 'https://pbs.twimg.com/profile_images/874276197357596672/kUuht00m_400x400.jpg',
                        link: 'https://twitter.com/MMelchiorsen/status/1182966899921039361',
                        date: '12-10-19',
                        likes: 5,
                        retweets: 5
                    },
                ];
            },
            getNews() {
                this.sentiments = [
                    { sentiment: 'Positive', newsCount: '1500', percentage: 15 },
                    { sentiment: 'Neutral', newsCount: '1000', percentage: 10 },
                    { sentiment: 'Negative', newsCount: '7500', percentage: 75 },
                ];
                this.news = [
                    {
                        title: 'EUR/USD Rate Week Ahead Forecast: Short-Term Trend Now Bullish',
                        overview: 'The Euro-to-Dollar exchange rate is trading at around 1.1035 at the start of the new week after rising 0.27% in the week before. Studies of the charts are showing the potential for more upside in the short-term dependent on a break to new highs.',
                        provider: 'Poundsterlinglive.com',
                        sentiment: 'Very Positive',
                        imageSrc: 'https://www.poundsterlinglive.com/images/stock/europe-euro-exchange-rate-4.jpg',
                        newsSource: 'https://www.poundsterlinglive.com/eurusd/12204-eur-usd-rate-week-ahead-forecast-short-term-trend-now-bullish',
                    },
                    {
                        title: 'EURUSD: outlook remains positive',
                        overview: 'EURUSD outlook remains positive if we hold above first support at 1.1010/00 after the buy signal, initially targeting 1.1050/60 (hit) & 1.1075/85, perhaps as far as 1.1100/10. Longs at 1.1010/00 need stops above 1.0980. An unexpected break below here kills the buy signal targeting 1.0950/40 & 1.0905/00 before the swing low at 1.0883/77.',
                        provider: 'FxStreet',
                        sentiment: 'Positive',
                        imageSrc: 'https://editorial.fxstreet.com/miscelaneous/jason-637066105909839336.png',
                        newsSource: 'https://www.fxstreet.com/analysis/eurusd-outlook-remains-positive-201910140044',
                    },
                    {
                        title: 'Murrey Math Lines 07.10.2019 (EURUSD, GBPUSD)',
                        overview: 'In the H4 chart, EURUSD is still consolidating. In this case, the price is expected to grow towards the resistance at 5/8. If later the pair breaks this level, it may continue moving upwards to reach the next resistance at 8/8. However, this scenario may no longer be valid if the price breaks 3/8 to the downside. After that, the instrument may continue falling towards the support at 1/8.',
                        provider: 'Roboforex.com',
                        sentiment: 'Negative',
                        imageSrc: 'https://www.roboforex.com/uploads/roboforecast/roboforex.com/99/2019/Murrey/october/07/1.PNG',
                        newsSource: 'https://www.roboforex.com/beginners/analytics/forex-forecast/murray-analysis/murray-eurusd-gbpusd-07102019/',
                    },
                ];
            }
        }
    }
</script>

<style scoped>

</style>
